<div class="body" [formGroup]="formGroup">

    <ng-container *ngIf="fixedReceiverSet; else receiverInput">

        <mat-form-field appearance="fill">
            <mat-label>Empfänger</mat-label>
            <mat-select formControlName="receiver">
                <mat-option *ngFor="let receiver of receiverSuggestions" [value]="receiver.value">
                    {{receiver.display}}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </ng-container>

    <mat-form-field appearance="fill">
        <mat-label>Betreff</mat-label>
        <input matInput formControlName="subject" autocomplete="off" type="text" />
        <mat-error *ngIf="subjectControl.hasError('required')">
            Es muss ein Betreff vorgesehen werden
        </mat-error>
    </mat-form-field>

    <div class="control-row">

        <div class="attachements" [matMenuTriggerFor]="attachementsMenu"
            *ngIf="typeControl.value === NotificationTaskType.EMail">

            <mat-icon class="icon">
                attach_file
            </mat-icon>

            <div class="text">
                {{attachements.controls? attachements.controls.length: 0}} Dateien angehangen
            </div>

        </div>

        <div class="drafts" [matMenuTriggerFor]="draftsMenu" *ngIf="drafts.length > 0">

            <mat-icon class="icon">
                lens
            </mat-icon>

            <div class="text">
                Vorlage verwenden
            </div>

        </div>

    </div>

    <quill-editor class="quill" theme="snow" [format]="'html'" formControlName="content" [modules]="quillModules">
    </quill-editor>

</div>

<mat-menu #attachementsMenu="matMenu">

    <ng-container *ngFor="let file of nextcloudFolder">

        <div *ngIf="!file.isItself" class="file-wrapper" (click)="fileClicked($event, file)">

            <mat-checkbox [checked]="attachedFilesReadonly[file.uuid]" (click)="$event.preventDefault()"></mat-checkbox>

            <app-nextcloud-file-preview class="file-preview" [file]="file"></app-nextcloud-file-preview>

        </div>

    </ng-container>

</mat-menu>

<mat-menu #draftsMenu="matMenu">

    <ng-container *ngFor="let draft of drafts">

        <button mat-menu-item (click)="setDraft(draft)">
            {{draft.internalDescription}}
        </button>

    </ng-container>

</mat-menu>

<ng-template #receiverInput>

    <mat-form-field appearance="fill" [formGroup]="formGroup">
        <mat-chip-list #chipList>
            <mat-chip *ngFor="let receiver of receiverControl.value" [removable]="true"
                (removed)="removeReceiver(receiver)">
                {{receiver}}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        </mat-chip-list>
        <input matInput class="custom-e-mail-input" [matAutocomplete]="receiverSuggestionsAuto" [formControl]="receiverFormControl" autocomplete="off" type="text" placeholder="Empfänger" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addReceiver($event?.value)" (blur)="tryAddEMail()" />
        <mat-autocomplete #receiverSuggestionsAuto="matAutocomplete">
            <mat-option *ngFor="let suggestion of receiverSuggestions" [value]="suggestion.value" (click)="addReceiver(suggestion.value)">
                {{suggestion.display}}
            </mat-option>
            <mat-option *ngIf="receiverSuggestions.length === 0" [value]="null">
                <span class="no-suggestions">
                    Wir haben leider keine Vorschläge für Sie
                </span>
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="receiverControl.hasError('required')">
            Eine Nachricht kann nicht ohne Empfänger versendet werden
        </mat-error>
        <mat-error *ngIf="!receiverControl.hasError('required') && receiverControl.hasError('email')">
            Ungültige E-Mail Adresse erkannt
        </mat-error>
    </mat-form-field>

</ng-template>